'use client';

import LOCATION_PATHS from '@lingo/adobe-analytics';
import { Accordion } from 'ui';

// @TODO: refactor to remove old unnecessary logic
export default function FAQ({ data }) {
  return (
    <>
      <div className='col-span-4 md:col-span-6'>
        <h2>{data?.sectionTitle || ''}</h2>
      </div>
      <div className='col-span-4 md:col-span-6 pb-10 md:pb-40'>
        <Accordion
          items={data?.allFaqItems?.items}
          analyticsLocation={LOCATION_PATHS.faq}
          setImageIndex={() => ({})}
        />
      </div>
    </>
  );
}
